import { InformationVariantCircleOutlineIcon } from './InformationVariantCircleOutlineIcon';

/**
 * author: Jeff Anders
 * id 1100F1C0-2FFF-49ED-99C3-AE0A2F0ECFF7
 * name information-variant-circle-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-variant-circle-outline.svg
 * tags
 * - Settings 
 */
export const InformationSerifCircleOutlineIcon = InformationVariantCircleOutlineIcon;
export default InformationSerifCircleOutlineIcon